import _ from "@lodash";
import { withStyles } from "@material-ui/core";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import * as AppActions from "app/store/actions";
import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import EmpresaPessoaCard from "./Components/EmpresaPessoaCard";
import EmpresaPessoaTable from "./Components/EmpresaPessoaTable";
import * as Actions from "./Store/Actions/EmpresaPessoaActions";

const styles = theme => ({
    root: {
        color: theme.palette.text.primary,
    }
});

class EmpresaPessoaList extends XAPPComponent {

    componentDidMount() {
        const { listFilter, target = "" } = this.props;
        listFilter(null, target?.replace("lookup", ""));
    }

    componentDidUpdate() {
        if (this.props.Pessoas.error) {
            this.props.showMessage({
                message: this.props.Pessoas.error,
                variant: "error"
            });
            this.props.Pessoas.error = null;
        }
    }

    nextPage = () => {
        const { listFilter, filter, Pessoas, target } = this.props;
        if (Pessoas.pagina < Pessoas.data[0].paginas) {
            listFilter(filter, target, Pessoas.pagina + 1);
        }
    };

    getArray = () => {
        var AArray = [];
        const { Pessoas, conditions } = this.props;

        if (!_.isUndefined(Pessoas.data) && !_.isNull(Pessoas.data) && Pessoas.data.length > 0) {
            Pessoas.data.forEach(item => {
                var AOkTag = true;
                if (conditions && (conditions.tags.length > 0)) {
                    if (!_.isNull(conditions.tags) && conditions.tags.length > 0) {
                        if (item.tags !== null) {
                            conditions.tags.split(",").forEach(tag => {
                                if (AOkTag && item.tags.includes(tag)) {
                                    AOkTag = true;
                                }
                                else {
                                    AOkTag = false;
                                }
                            });
                        }
                        else {
                            AOkTag = false;
                        }
                    }
                }

                if (AOkTag) {
                    AArray.push(item);
                }
            });

        }
        return AArray;
    };

    getTags = (_AData) => {
        const { TagsPessoa = null } = this.props;
        let AResponse = [];
        if (!_.isNull(TagsPessoa) && TagsPessoa.length > 0 && !_.isUndefined(_AData.tags) && !_.isNull(_AData.tags)) {
            TagsPessoa.forEach(tag => {
                if (_AData.tags.includes(tag.codigo)) {
                    AResponse.push({ "id": tag.idtagpessoaformulario, "title": tag.tagnome, "color": tag.cor });
                }
            });
        }
        return AResponse;
    };

    render() {
        const { openProntuario, xappRouteParams, get, target } = this.props;

        return (
            <React.Fragment>
                {_.isUndefined(openProntuario) &&
                    <EmpresaPessoaTable
                        {...this.props}
                        data={this.getArray()}
                        showContatos={!_.isUndefined(openProntuario)}
                        nextPage={this.nextPage}
                        onClick={ev => get(ev.idpessoaformulario, xappRouteParams, target)}
                        getTags={this.getTags}
                    />
                }

                {!_.isUndefined(openProntuario) &&
                    <div className="flex flex-wrap gap-8 p-8">
                        {this.getArray().map(item => (
                            <EmpresaPessoaCard
                                key={item.idpessoaformulario}
                                data={item}
                                xappRouteParams={xappRouteParams}
                                onClick={ev => openProntuario(ev)}
                                getTags={this.getTags}
                            />
                        ))}
                    </div>
                }
            </React.Fragment>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        list: Actions.list,
        get: Actions.get,
        showMessage: AppActions.showMessage,
    }, dispatch);
}

function mapStateToProps({ Pessoa }) {
    return {
        Pessoas: Pessoa.EmpresaPessoaReducer,
        TagsPessoa: Pessoa.TagFuncionalidadeReducer["pessoa"],
    };
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(EmpresaPessoaList)));
